import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var AddConnectionsComponent = /** @class */ (function () {
    function AddConnectionsComponent(data, dashboardService, errorHandlerService, router) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.subscriptions = [];
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.isSessionExpired = false;
    }
    AddConnectionsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    AddConnectionsComponent.prototype.ngOnInit = function () {
        console.log('addconn');
    };
    AddConnectionsComponent.prototype.gmailClick = function () {
        console.log('addconnclick');
        this.router.navigate(['dashboard/gmailconnections']);
    };
    AddConnectionsComponent.prototype.ngOnDestroy = function () {
    };
    AddConnectionsComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return AddConnectionsComponent;
}());
export { AddConnectionsComponent };
//# sourceMappingURL=addConnections.component.js.map